module.exports = __webpack_public_path__ + "img/box-cross-outlined-grey.e8409a6a.svg";